import React, { memo } from 'react'
import { CurrencyInput } from 'transfix-ui/components/CurrencyInput'
import { RADIUS_RATE } from 'apps/marketplace/utils/constants/rates'
import { ChangeRateData } from 'apps/marketplace/utils/helpers/useCarrier'

interface IRateProps {
  rateType: string
  rate: string
  onChange: (arg: Partial<ChangeRateData>) => void
}

export const Rate = memo<IRateProps>(({ onChange, rate, rateType }) => {
  if (rateType === RADIUS_RATE) {
    return <></>
  }

  const onRateChange = ({ value }: { value: string }) => onChange({ rate: value })

  return (
    <div className='col-md-2 col-xs-4'>
      <CurrencyInput
        placeholder='$'
        label='Lane Rate'
        value={Number(rate) || undefined}
        onChange={onRateChange}
        decimalScale={2}
        fixedDecimalScale
        dataTest='add-rate'
        required
      />
    </div>
  )
})
